import * as actions from "./actions";
import { initialState } from "../reducer";

export function originatorsSubreducer(state = initialState, action) {
  switch (action.type) {
    case actions.ORIGINATOR_GET_REQUEST:
      return Object.assign({}, state, {
        originators: Object.assign({}, state.originators, {
          fetching: true,
        }),
      });
    case actions.ORIGINATOR_GET_SUCCESS: {
      return Object.assign({}, state, {
        originators: Object.assign({}, state.originators, {
          fetching: false,
          fetched: true,
          data: action.response,
        }),
      });
    }
    case actions.ORIGINATOR_GET_ERROR:
      return Object.assign({}, state, {
        originators: Object.assign({}, state.originators, {
          error: action.error,
          fetching: false,
        }),
      });
    default:
      return state;
  }
}
